export type LoaderError = {
  message?: string;
  errno?: string | number;
  data?: unknown;
};

export type LoaderResult<T> = {
  data: T | null;
  error: LoaderError | null;
};

export function loaderSuccess<T>(data: T): LoaderResult<T> {
  return {
    data,
    error: null,
  };
}

export function loaderFailure(error: any): LoaderResult<never> {
  return {
    data: null,
    error: {
      message: error?.message || error?.errmsg || "Network Busy.",
      errno: error?.errno,
      data: error?.data,
    },
  };
}

export function resolveLoaderResult<T>(promise: Promise<T>): Promise<LoaderResult<T>> {
  return promise
    .then((data) => loaderSuccess(data))
    .catch((error) => loaderFailure(error) as LoaderResult<T>);
}
